<div class="card text-center">
  <div class="card-body d-flex flex-column">
    <h4 class="card-title text-primary text-center custom-tile-header">
      {{ 'local_listings.title_google_views' | translate}}
      <small>
        <helpPopover placement='top' html="{{ 'local_listings.help_google_views' | translate }}"></helpPopover>
      </small>
    </h4>
    @if (chartData.hasData) {
      <h6 class="text-secondary">({{ graphSubtitle }})</h6>
    }
    <div *ngIf="chartData" class="row">
      <app-google-business-profile-status [googleBusinessProfileStatus]="googleBusinessProfileStatus" [hasChartData]="chartData.hasData" [locationId]="locationId"></app-google-business-profile-status>
      <div class="col-12">
        <div class="p-2 text-center text-md-left d-flex flex-column h-100">
          <canvas class="chart-canvas" baseChart
                  [data]="data"
                  [labels]="labels"
                  [options]="options"
                  [colors]="chartColors"
                  [type]="'line'"></canvas>
        </div>
      </div>
      <div class="col-6">
        <div><i class="far fa-eye"></i> {{ totalViews }}</div>
        <div>{{ 'local_listings.stats_google_views_on_maps_and_search' | translate }}</div>
      </div>
      <div class="col-6">
        <div><i class="fas fa-directions"></i> {{ directionRequestConversionRate | percent: '1.2-2' }}</div>
        <div>{{ 'local_listings.stats_google_direction_conversion_rate' | translate }}</div>
      </div>
    </div>
  </div>
</div>
